import { PrivacyComponent } from './features/shared/components/privacy/privacy.component';
import { LegalComponent } from './features/shared/components/legal/legal.component';
import { SPHUserRole } from './features/shared/model/sph-user.model';
import { LicenseManagerService } from './features/shared/licensemanager-service/licensemanager.service';
import { SPHLoggedInUser } from './features/shared/model/sph-logged-in-user.model';
import { LoginComponent } from './features/userManagement/userManagement';
import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { CompaniesComponent, CompanyLicenseSettingsComponent, CompanyDetailsComponent } from './features/companyLicenseManagement/companyLicenseManagement';

import { BehaviorSubject } from 'rxjs';
import { MenuEntry } from './features/shared/shared';
import { LoadingController } from 'ionic-angular/components/loading/loading-controller';
import { UsersComponent } from './features/userManagement/usersComponent/users.component';
@Component({
  templateUrl: 'app.html'
})
// tslint:disable-next-line:component-class-suffix
export class MyApp {
  private menuEntries: MenuEntry[] = [];
  private user?: SPHLoggedInUser;

  private versionText = ''; // "LM-Version: 0.9\nBackend-Version: ??";

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, private loadingController: LoadingController, private licenseManagerService: LicenseManagerService) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
    });

    this.licenseManagerService.authErrorLogginRequired$.skip(1).subscribe( () => {
      this.user = undefined;
    });

  }

  public loggedInUser(user: SPHLoggedInUser) {
    const defaultMenuEntries = []; /*[{
      menuTitle: 'Impressum',
      component: LegalComponent,
      userdata: { user },
      order: 9,
    }, {
      menuTitle: 'Datenschutz',
      component: PrivacyComponent,
      userdata: { user },
      order: 10,
    }];*/

    if (user.role <= SPHUserRole.Guest) {
      // ??
    } else if (user.role >= SPHUserRole.User && user.adminForCompany !== undefined && user.role < SPHUserRole.Admin) {
      const indicator = this.loadingController.create();
      indicator.present();

      this.licenseManagerService.getCompany(user.adminForCompany, user.jwt).subscribe( (company) => {
        this.menuEntries = [{
          menuTitle: 'Firma',
          component: CompanyDetailsComponent,
          userdata: { user, company },
          order: 0,
        }];
        this.user = user;
        this.menuEntries = this.menuEntries.concat(defaultMenuEntries);

      }, undefined, () => {
        indicator.dismiss();
      });
    } else if (user.role >= SPHUserRole.Admin && user.role < SPHUserRole.SuperAdmin) {
      this.menuEntries = [{
        menuTitle: 'Kundenübersicht',
        component: CompaniesComponent,
        userdata: { user },
        order: 0,
      },
      {
        menuTitle: 'Einstellungen',
        component: CompanyLicenseSettingsComponent,
        userdata: { user },
        order: 1,
      }];
    } else if (user.role >= SPHUserRole.SuperAdmin) {
      this.menuEntries = [{
        menuTitle: 'Kundenübersicht',
        component: CompaniesComponent,
        userdata: { user },
        order: 0,
      },
      {
        menuTitle: 'Einstellungen',
        component: CompanyLicenseSettingsComponent,
        userdata: { user },
        order: 1,
      },
      {
        menuTitle: 'Nutzerverwaltung',
        component: UsersComponent,
        userdata: { user },
        order: 2,
      }];
    }
    this.user = user;

    this.menuEntries = this.menuEntries.concat(defaultMenuEntries);
  }

  public didTapLogout() {
    this.menuEntries = [];
    this.user = undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts